import ConsentModel from './consent'
import ConsentedStubModel from './consented-stub'
import DissentedStubModel from './dissented-stub'
import {searchParams} from '../util/location'
import debug, {WARN} from '../util/debug'

export default function (baseURL: string, Dflt: typeof ConsentModel): Promise<ConsentModel> {
  if (searchParams['mol.ads.cmp.stubConsent']) {
    debug('stubbing consent', WARN)
    return ConsentedStubModel.load(baseURL)
  } else if (searchParams['mol.ads.cmp.stubDissent']) {
    debug('stubbing dissent', WARN)
    return DissentedStubModel.load(baseURL)
  } else {
    return Dflt.load(baseURL)
  }
}
